module.exports = __webpack_public_path__ + "img/default-image-narrative.b8696ecf.jpg";